import { Field, Form, Formik } from "formik";
import moment from "moment";
import "moment-timezone";
import React, { Component } from "react";
import {
  Alert as BSAlert,
  Button,
  Checkbox,
  ControlLabel
} from "react-bootstrap";
import Alert from "react-s-alert";
import * as Yup from "yup";
import FormikDatetime from "../Shared/FormikDateTime";
import FormikFormControl from "../Shared/Forms/FormikFormControl";
import FormikTextAreaControl from "../Shared/Forms/FormikTextAreaControl";
import DealsService from "../utils/DealsService";
import UsersService from "../utils/UsersService";

class NoSaleForm extends Component {
  state = {
    addFollowUp: false,
    addDueDate: false,
    users: []
  };

  constructor(props) {
    super(props);
    UsersService.allUsers().then(data => {
      this.setState({ users: data });
    });
  }

  render() {
    const { noSaleType, onCancelSubmit } = this.props;
    const isNoSale = noSaleType === "no_sale";
    const isDeadDeal = noSaleType === "dead_deal";
    const title = isNoSale ? "No Sale" : "Dead Deal";

    const validationSchema = Yup.object().shape({
      assign_lead_to: Yup.string(),
      no_sale_reason: Yup.string().required("Reason is required"),

      ineligable_no_sale_reason: Yup.string().when(["no_sale_reason"], {
        is: reason => reason === "ineligible",
        then: schema => schema.required("Ineligible Reason is required"),
        otherwise: schema => schema.notRequired()
      }),

      notes_no_sale: Yup.string().required("Rep notes are required").min(15, "minimum 15 characters").max(2000, "maximum 2000 characters"),

      lead_type: Yup.string().when("no_sale_reason", {
        is: val => this.state.addFollowUp,
        then: Yup.string().required("Type is required"),
        otherwise: Yup.string().notRequired()
      }),

      priority: Yup.string().when("no_sale_reason", {
        is: val => this.state.addFollowUp,
        then: Yup.string().required("Priority is required"),
        otherwise: Yup.string().notRequired()
      }),

      due_at: Yup.date().when("no_sale_reason", {
        is: val => this.state.addFollowUp && this.state.addDueDate,
        then: Yup.date().required(),
        otherwise: Yup.date().notRequired()
      }),
      initial_notes: Yup.string().when("no_sale_reason", {
        is: val => this.state.addFollowUp,
        then: Yup.string().max(2000, "maximum 2000 characters"),
        otherwise: Yup.string().notRequired()
      })
    });

    const { users } = this.state;
    return (
      <Formik
        initialValues={{
          no_sale_reason: "",
          notes_no_sale: "",
          lead_type: "",
          assign_lead_to: "",
          initial_notes: "",
          ineligable_no_sale_reason: "",
          priority: 3,
          due_at: moment()
            .add(3, "days")
            .hours(8)
            .startOf("hour")
            .toDate()
        }}
        validationSchema={validationSchema}
        onSubmit={(values, { setSubmitting }) => {
          setSubmitting(true);
          const { onSubmit } = this.props;
          const { deal } = this.props;

          values.add_follow_up = this.state.addFollowUp;
          values.add_due_date = this.state.addDueDate;

          DealsService.takeAction(noSaleType, deal.id, values).then(data => {
            Alert.success("Updated");
            onSubmit(data);
            setSubmitting(false);
          });
        }}
        render={({
          errors,
          touched,
          isValid,
          isSubmitting,
          values,
          setFieldValue,
          setFieldTouched
        }) => {
          const ineligibleSelected = values.no_sale_reason === "ineligible";

          // hide follow-up for specific dead deal reasons
          const hideFollowUp =
            isDeadDeal &&
            [
              "duplicate_lead",
              "reschedule_-_agent_availability",
              "reschedule_-_cx_availability",
              "ineligible"
            ].includes(values.no_sale_reason);
          return (
            <Form>
              {isNoSale && (
                <BSAlert bsStyle="warning">
                  <p>
                    This will be passed to Admin for them to follow up, you
                    won't get another option to make the sale
                  </p>
                </BSAlert>
              )}
              {isDeadDeal && (
                <BSAlert bsStyle="warning">
                  <p>This will close this as a dead deal</p>
                </BSAlert>
              )}
              <FormikFormControl
                fieldName="no_sale_reason"
                errors={errors}
                touched={touched}
              >
                <ControlLabel>Reason for not making the sale</ControlLabel>
                <Field
                  className="form-control input-sm"
                  name="no_sale_reason"
                  component="select"
                >
                  <option value="">-- select --</option>
                  {isDeadDeal && (
                    <React.Fragment>
                      <option value="sms_cancellation">SMS Cancellation</option>
                      <option value="1/2_parent_availability">
                        1/2 Parent Availability
                      </option>
                      <option value="no_longer_interested_-_student">
                        No Longer Interested - Student
                      </option>
                      <option value="no_longer_interested_-_parent">
                        No Longer Interested - Parent
                      </option>
                      <option value="reschedule_-_agent_availability">
                        Reschedule - Agent Availability
                      </option>
                      <option value="reschedule_-_cx_availability">
                        Reschedule - CX availability
                      </option>
                      <option value="duplicate_lead">Duplicate Lead</option>
                      <option value="ineligible">Ineligible</option>
                    </React.Fragment>
                  )}
                  {isNoSale && (
                    <React.Fragment>
                      <option value="couldnt_afford">Couldn't afford it</option>
                      <option value="no_longer_interested_-_student">
                        No Longer Interested - Student
                      </option>
                      <option value="no_longer_interested_-_parent">
                        No Longer Interested - Parent
                      </option>
                      <option value="wanted_tutor">
                        Wanted a tutor instead
                      </option>
                      <option value="other">Other</option>
                    </React.Fragment>
                  )}
                </Field>
              </FormikFormControl>

              {ineligibleSelected && (
                <FormikFormControl
                  fieldName="ineligable_no_sale_reason"
                  errors={errors}
                  touched={touched}
                >
                  <ControlLabel>Reason for ineligibility</ControlLabel>
                  <Field
                    className="form-control input-sm"
                    name="ineligable_no_sale_reason"
                    component="select"
                  >
                    <option value="">-- select --</option>
                    <React.Fragment>
                      <option value="non_english_speaking">
                        Non English Speaking
                      </option>
                      <option value="no_device">No Device</option>
                      <option value="primary_student">Primary Student</option>
                      <option value="year_12_student_(_term_4_only_)">
                        Year 12 Student (Term 4 Only)
                      </option>
                      <option value="requested_no_further_contact">
                        Requested no further contact
                      </option>
                      <option value="bad_number">Bad number</option>
                      <option value="poor_quality_lead">
                        Poor Quality Lead
                      </option>
                    </React.Fragment>
                  </Field>
                </FormikFormControl>
              )}

              <FormikTextAreaControl
                fieldLabel="Notes / Explanation"
                fieldName="notes_no_sale"
                errors={errors}
                touched={touched}
              />

              {!hideFollowUp && (
                <Checkbox
                  checked={this.state.addFollowUp}
                  onChange={() => {
                    this.setState({
                      addFollowUp: !this.state.addFollowUp
                    });
                  }}
                >
                  Create a Follow Up?
                </Checkbox>
              )}

              {this.state.addFollowUp && (
                <div>
                  <FormikFormControl
                    fieldName="lead_type"
                    errors={errors}
                    touched={touched}
                  >
                    <ControlLabel>Follow Up Type</ControlLabel>
                    <Field
                      className="form-control input-sm"
                      name="lead_type"
                      component="select"
                    >
                      <option value="">-- select --</option>
                      <option value="could_not_present_tcs">
                        Couldn't present TCS
                      </option>
                      <option value="could_not_confirm_tcs">
                        Couldn't confirm TCS
                      </option>
                      <option value="seminar_attended_did_not_book">
                        Seminar attended, did not book TCS
                      </option>
                      <option value="seminar_register_did_not_attend">
                        Booked Seminar, did not attend
                      </option>
                      <option value="dead_deal">Dead Deal</option>
                      <option value="other">Other</option>
                    </Field>
                  </FormikFormControl>

                  <FormikFormControl
                    fieldName="priority"
                    errors={errors}
                    touched={touched}
                  >
                    <ControlLabel>Follow Up Priority</ControlLabel>
                    <Field
                      className="form-control input-sm"
                      name="priority"
                      component="select"
                    >
                      <option value="1">Urgent</option>
                      <option value="2">High Priority</option>
                      <option value="3">Normal</option>
                      <option value="4">Low Priority</option>
                      <option value="5">Unimportant</option>
                    </Field>
                    import UsersService from '../utils/UsersService';
                  </FormikFormControl>

                  <FormikFormControl
                    fieldName="assign_lead_to"
                    errors={errors}
                    touched={touched}
                  >
                    <ControlLabel>Assign it to</ControlLabel>
                    {users && (
                      <Field
                        className="form-control input-sm"
                        name="assign_lead_to"
                        component="select"
                      >
                        <option value="">-- nobody --</option>
                        {users &&
                          users.map(user => {
                            return (
                              <option key={user.email} value={user.email}>
                                {user.name}
                              </option>
                            );
                          })}
                      </Field>
                    )}
                  </FormikFormControl>

                  <FormikTextAreaControl
                    fieldLabel="Initial Notes / Explanation"
                    fieldName="initial_notes"
                    errors={errors}
                    touched={touched}
                  />

                  <Checkbox
                    checked={this.state.addDueDate}
                    onChange={() => {
                      this.setState({
                        addDueDate: !this.state.addDueDate
                      });
                    }}
                  >
                    Add a Due Date?
                  </Checkbox>

                  {this.state.addDueDate && (
                    <FormikFormControl
                      fieldName="due_at"
                      errors={errors}
                      touched={touched}
                    >
                      <ControlLabel>When</ControlLabel>
                      <FormikDatetime
                        field="due_at"
                        input={{
                          value: moment(values.due_at).format(
                            "DD MMM YYYY h:mma"
                          ),
                          onChange: setFieldValue,
                          onBlur: setFieldTouched
                        }}
                        closeOnSelect={true}
                        dateFormat="DD MMM YYYY"
                        timeFormat="h:mma"
                      />
                    </FormikFormControl>
                  )}
                </div>
              )}

              <div>
                {onCancelSubmit && (
                  <Button onClick={onCancelSubmit} bsSize="small">
                    Whoops, cancel this
                  </Button>
                )}
                <Button
                  className="pull-right"
                  disabled={!isValid || isSubmitting}
                  type="submit"
                  bsStyle="danger"
                  bsSize="small"
                >
                  Go ahead and Mark {title}
                </Button>
              </div>
            </Form>
          );
        }}
      />
    );
  }
}

export default NoSaleForm;
